<template>
  <v-form v-model="valid" ref="mainForm">
    <data-iterator
      :list="sas.employeurs"
      add-new-text="Ajouter un employeur"
      :live="{ endpoint: 'sas-cartes-affaires', sasId: sas.id }"
      :icon="$getIcon('job')"
      :valids="valids"
      ref="dataIterator"
    >
      <template v-slot:show-mode="{ item }">
        <h3>{{ item.nomEmployeur }}</h3>
        <p class="my-0">
          {{ item.adresse }}
        </p>
        <p class="my-0">{{ item.ville }}</p>
      </template>
      <template v-slot:edit-mode="{ item }">
        <search-organisation @organisation-selected="organisationSelected($event, item.id)"></search-organisation>
        <opq-text-field
          code="nom-employeur"
          v-model="item.nomEmployeur"
          :live="liveSasCartesAffaires(2908, item)"
          :ref="'nomEmployeur' + item.id"
        ></opq-text-field>

        <opq-catalogue
          code="emploi-milieu-travail-1"
          v-model="item.milieuTravail1"
          :live="liveSasCartesAffaires(2907, item)"
          width="500"
          :filter="(fd) => fd.value != item.milieuTravail2 && fd.value != item.milieuTravail3"
        >
        </opq-catalogue>
        <opq-catalogue
          code="emploi-milieu-travail-2"
          v-model="item.milieuTravail2"
          :live="liveSasCartesAffaires(2909, item)"
          optional
          width="500"
          :filter="(fd) => fd.value != item.milieuTravail1 && fd.value != item.milieuTravail3"
        >
        </opq-catalogue>
        <opq-catalogue
          code="emploi-milieu-travail-3"
          v-model="item.milieuTravail3"
          :live="liveSasCartesAffaires(2910, item)"
          optional
          width="500"
          :filter="(fd) => fd.value != item.milieuTravail1 && fd.value != item.milieuTravail2"
        >
        </opq-catalogue>
        
        <adresse-professionnelle :carteAffaire="item" :ref="'adresse-' + item.id"></adresse-professionnelle>

        <opq-date-picker code="date-debut-emploi" hide-day v-model="item.dateDebutEmploi" :live="liveSasCartesAffaires(2939, item)"></opq-date-picker>
        <opq-date-picker
          code="date-fin-emploi"
          hide-day
          v-model="item.dateFinEmploi"
          optional
          :live="liveSasCartesAffaires(2940, item)"
        ></opq-date-picker>
      </template>
    </data-iterator>
  </v-form>
</template>

<script>
import FormHybrid from "@/mixins/FormHybrid"
import SearchOrganisation from "@/components/Common/SearchOrganisation"
import AdresseProfessionnelle from "../FormParts/AdresseProfessionnelle"
export default {
  mixins: [FormHybrid],
  props: {
    sas: { type: Object }
  },
  components: { SearchOrganisation, AdresseProfessionnelle },
  methods: {
    liveSasCartesAffaires(cle, item) {
      return { endpoint: "sas-cartes-affaires", cle: cle, fileId: item.id }
    },
    organisationSelected(organisation, id) {
      let adresse = this.$refs["adresse-" + id].$refs.adresse
      this.$refs["nomEmployeur" + id].setValue(organisation.nomEmployeur)
      adresse.$refs.adresse.setValue(organisation.adresse)
      adresse.$refs.complementAdresse.setValue(organisation.complementAdresse)
      adresse.$refs.ville.setValue(organisation.ville)
      adresse.$refs.codePostal.setValue(organisation.codePostal)
      adresse.$refs.province.setValue(organisation.province)
      adresse.$refs.pays.setValue(organisation.pays)
    }
  }
}
</script>

<style>
</style>